module.exports = __webpack_public_path__ + "static/vxdms2018-15f8dbcfa20a11cf2d8b37d3ba8de846.png";